import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
// Deep import, not the @livingsyncs/ui barrel — same reason as lib/platform.ts
// (module-evaluation order); this runs before anything else in main.tsx.
import { initCognitoClients } from "@livingsyncs/ui/src/lib/cognitoClients";
import { desktop } from "@/lib/platform";
import { restoreAuthPersistence } from "@/lib/authPersistence";

const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
// US-176 — the PIN fast re-auth app client. Optional: without it the app
// never offers PIN setup or PIN sign-in (lib/cognitoClients.ts).
const reauthClientId = import.meta.env.VITE_COGNITO_REAUTH_CLIENT_ID;

if (!userPoolId || !userPoolClientId) {
  throw new Error(
    "Missing Cognito environment variables: VITE_COGNITO_USER_POOL_ID, VITE_COGNITO_CLIENT_ID",
  );
}

// Configures Amplify on whichever app client the last session used (a PIN
// session's tokens are stored under the re-auth client's keys).
initCognitoClients({
  base: {
    userPoolId,
    loginWith: { email: true },
    mfa: { status: "on", totpEnabled: true },
  },
  mainClientId: userPoolClientId,
  reauthClientId,
});

// US-013 AC10 — on desktop, store Cognito tokens in the OS keychain (via the
// main process over IPC) instead of plaintext localStorage. The bridge's
// tokenStore implements Amplify's async KeyValueStorageInterface. When
// safeStorage is unavailable (`available: false`) we leave Amplify's default
// (FileVault-protected) store in place — never a blocker.
if (desktop?.tokenStore.available) {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(desktop.tokenStore);
} else {
  // Web: HIPAA — restore the user's saved "Remember me" choice (session-only by
  // default) before any auth call reads a token. See lib/authPersistence.ts.
  restoreAuthPersistence();
}
